import React, { useState, useEffect, useRef } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { ChevronDown, ChevronUp } from 'lucide-react';
import '../css/filters.css';
import { useTranslation } from 'react-i18next';

const Filters = ({ minDate, maxDate, onDateRangeChange }) => {
  const [showFilters, setShowFilters] = useState(false);
  const [range, setRange] = useState([minDate, maxDate]);
  const sliderRef = useRef(null);
  const containerRef = useRef(null);
  const [sliderWidth, setSliderWidth] = useState(0);
  const [handlePositions, setHandlePositions] = useState([0, 0]);
  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowFilters(false);
      }
    };

    if (showFilters) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showFilters]);

  useEffect(() => {
    setRange([minDate, maxDate]);
  }, [minDate, maxDate]);
  
  useEffect(() => {
    if (sliderRef.current) {
      setSliderWidth(sliderRef.current.offsetWidth);
    }
    const handleResize = () => {
      if (sliderRef.current) setSliderWidth(sliderRef.current.offsetWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [showFilters]);

  useEffect(() => {
  if (sliderRef.current) {
    const handles = sliderRef.current.querySelectorAll('.rc-slider-handle');
    setHandlePositions([handles[0].offsetLeft + handles[0].offsetWidth / 2, handles[1].offsetLeft + handles[1].offsetWidth / 2]);
  }
}, [range, sliderWidth]);

  const handleRangeChange = (values) => {
    setRange(values);
    onDateRangeChange([new Date(values[0]), new Date(values[1])]);
  };

  const formatDate = (timestamp) => {
    const d = new Date(timestamp);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = String(d.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
  };

  // eslint-disable-next-line no-unused-vars
  const getPosition = (value) => {
    if (!sliderWidth) return 0;
    return ((value - minDate) / (maxDate - minDate)) * sliderWidth;
  };
  
  return (
  <div className="filters-container" ref={containerRef}>
  <div className="filters-range">
    <button
      className="toggle-btn"
      onClick={() => setShowFilters(!showFilters)}
    >
      <span className="range-filters-label">
        {t('stats.filters.value')} {showFilters ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </span>
      <span className="range-label">
        {formatDate(range[0])} - {formatDate(range[1])}
      </span>
    </button>
  </div>

  {showFilters && (
        <div className="filter-slider" ref={sliderRef}>
          <p className="header-filter-title">{t('stats.filters.header')}</p>
          <div className="slider-container" style={{ position: 'relative' }}>
            {/* Slider */}
            <div className="slider-component">
              <Slider
                range
                min={minDate}
                max={maxDate}
                step={24 * 60 * 60 * 1000}
                value={range}
                onChange={handleRangeChange}
                allowCross={false}
                styles={{
                  rail: {
                    backgroundColor: '#ccc', 
                    height: 10,             
                  },
                  track: {
                    backgroundColor: '#4caf50', 
                    height: 10,
                  },
                  handle: {
                    borderColor: '#4caf50',
                    backgroundColor: '#fff',
                    height: 22,
                    width: 22,
                    marginTop: -6,
                  },
                }}
              />
            </div>

            {/* Dates dynamiques au-dessus des poignées */}
            <div className="slider-selected-labels"
              style={{ position: 'absolute', top: -20, width: '100%' }}
            >
              <span className="slider-dynamic-label" style={{left: handlePositions[0]}}>
                {formatDate(range[0])}
              </span>
              <span className="slider-dynamic-label" style={{left: handlePositions[1]}}>
                {formatDate(range[1])}
              </span>
            </div>

            {/* Dates fixes en bas */}
            <div className="slider-fixed-labels">
              <span>{formatDate(minDate)}</span>
              <span>{formatDate(maxDate)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Filters;
